<template>
    <Breadcrumbs main="Job Search" title="Cards View" />
    <div class="container-fluid">
        <div class="row">
            <jobSidebar />
            <cardView />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const jobSidebar = defineAsyncComponent(() => import("@/components/commen/jobSidebar.vue"))
const cardView = defineAsyncComponent(() => import("@/components/theme/job/card/cardView.vue"))
</script>